import React from 'react';
import { useSelector } from 'react-redux';

import Group from './Group';

const Survey = () => {
  const commands = useSelector((state) => state.mission.json.commands);

  return (
    <>
      {commands
        .filter(({ type }) => type === 'cusSurvey')
        .map((command) => {
          const index = commands.findIndex(({ id }) => command.id === id);
          return <Group key={index} index={index} data={command.data} />;
        })}
    </>
  );
};

export default Survey;
